import React from "react";

export const SocialMediaFacebook1 = ({ className }) => {
  return (
    <svg
      className={`social-media-facebook-1 ${className}`}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="path"
        d="M12 2.5C9.48044 2.5 7.06408 3.50089 5.28249 5.28249C3.50089 7.06408 2.5 9.48044 2.5 12C2.5 14.5196 3.50089 16.9359 5.28249 18.7175C7.06408 20.4991 9.48044 21.5 12 21.5C14.5196 21.5 16.9359 20.4991 18.7175 18.7175C20.4991 16.9359 21.5 14.5196 21.5 12C21.5 9.48044 20.4991 7.06408 18.7175 5.28249C16.9359 3.50089 14.5196 2.5 12 2.5Z"
        fill="#1877F2"
      />

      <path
        className="path"
        d="M13.286 14.518H15.7445L16.1305 12.0205H13.2855V10.6555C13.2855 9.618 13.6245 8.698 14.595 8.698H16.1545V6.5185C15.8805 6.4815 15.301 6.4005 14.206 6.4005C11.9195 6.4005 10.579 7.608 10.579 10.359V12.0205H8.2285V14.518H10.579V21.3825C11.0445 21.4525 11.516 21.5 12 21.5C12.4375 21.5 12.8645 21.46 13.286 21.403V14.518Z"
        fill="white"
      />
    </svg>
  );
};
